import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const DeleteConfirm = ({ open, onOpenChange, onConfirm, itemName }) => (
  <Dialog
    open={open}
    onClose={() => onOpenChange(false)}
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle>Delete {itemName}?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This will permanently remove <strong>{itemName}</strong> and all its
        nested data. This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => onOpenChange(false)}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirm;
